import { StoreConfig, Store } from '@datorama/akita';
import { Injectable } from '@angular/core';
import * as storage from './storage';
import { User } from '@23degrees/shared-code/models';
import { Product } from '@23degrees/shared/models/pricing/products.model';

// tslint:disable-next-line:interface-over-type-literal
export type AuthState = {
  token: string;
  id: string;
  user: User;
  permissions: { name: string; resource: string }[];
  products: Product[];
};
/**
 * [createInitialSessionState description]
 * @return [description]
 */

export function createInitialSessionState(): AuthState {
  return {
    token: null,
    id: null,
    user: null,
    permissions: [],
    products: [],
    ...storage.getAuth(),
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'auth' })
export class AuthStore extends Store<AuthState> {
  constructor() {
    super(createInitialSessionState());
  }

  getInitialState() {
    return createInitialSessionState();
  }
}
